/* global document */
import Global from './global';
import header from './components/header';
import carouselBanner from './components/hero-carousel';
import eventModal from './components/event-modal';
import mediaSection from './components/media-section';
import roadmap from './components/roadmap';
import registerEvent from './components/register-event';
import eventList from './components/event-list';
import languageSwitcher from './components/language-switcher';
import timeline from './components/timeline';
import determineActivePage from './components/determine-active-page';
import truncateText from './components/truncate-text';
import table from './components/table';
import myProfile from './components/my-profile';
import pageContent from './components/page-content';
import contactUs from './components/contact-us';
import { addEnvironmentClasses } from './utils/add-environment-class';


document.addEventListener('DOMContentLoaded', () => {
  const g = new Global();
  g.init();

  header();
  carouselBanner();
  eventModal();
  addEnvironmentClasses();
  mediaSection();
  roadmap();
  registerEvent().init();
  eventList();
  languageSwitcher().init();
  timeline();
  determineActivePage();
  truncateText();
  table().sort();
  myProfile().init();
  pageContent();

  contactUs().init();
});
